import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'members-package-description',
  standalone: true,
  templateUrl: './package-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageDescriptionComponent {
  readonly vendorPackageName = input<string | undefined>();
  readonly internalDescription = input<string | undefined>();
}